// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StockPreimpresos_container__WVcVy {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_header__e9bbN {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_header__e9bbN .StockPreimpresos_titleContainer__gMD8a {
  animation: StockPreimpresos_toright__tussI 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_header__e9bbN .StockPreimpresos_titleContainer__gMD8a h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_loader__MdmxO {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  height: 600px;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_data__kz5bp {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
}

/*---Información---*/
.StockPreimpresos_container__WVcVy .StockPreimpresos_data__kz5bp .StockPreimpresos_tableContainer__jnJ-- {
  animation: StockPreimpresos_toleft__WPxJZ 0.3s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_data__kz5bp .StockPreimpresos_tableContainer__jnJ-- .StockPreimpresos_tableTitle__KX3Kf {
  font-size: 0.9rem;
  font-weight: 500;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf .StockPreimpresos_item__E9H9z {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  margin-right: 10px;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf h4 {
  font-size: 1.3rem;
  font-weight: 300;
  margin-top: 0;
  animation: StockPreimpresos_toleft__WPxJZ 0.5s both;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf .StockPreimpresos_loaderGames__Hzcli {
  animation: StockPreimpresos_init__jlo0A 0.5s 0.2s both;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf .StockPreimpresos_init1__q6Rpj {
  animation: StockPreimpresos_init__jlo0A 0.5s 0.2s both;
}
.StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf .StockPreimpresos_init2__lBHRC {
  animation: StockPreimpresos_init__jlo0A 0.5s 0.4s both;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_options__8PoS3 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.StockPreimpresos_container__WVcVy .StockPreimpresos_options__8PoS3 p {
  margin: 0 0 0 10px;
  text-transform: capitalize;
  font-weight: 300;
}

@keyframes StockPreimpresos_init__jlo0A {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes StockPreimpresos_toright__tussI {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes StockPreimpresos_toleft__WPxJZ {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media print {
  @page {
    size: landscape;
    margin: 50px 0 50px;
    quotes: none;
    visibility: visible;
  }

  .StockPreimpresos_container__WVcVy .StockPreimpresos_header__e9bbN {
    display: none !important;
  }

  .StockPreimpresos_container__WVcVy .StockPreimpresos_filters__pynhf {
    display: none !important;
  }

  .StockPreimpresos_container__WVcVy .StockPreimpresos_data__kz5bp {
    min-width: 99%;
  }

  .StockPreimpresos_container__WVcVy .StockPreimpresos_data__kz5bp .StockPreimpresos_tableContainer__jnJ-- {
    box-shadow: none;
    border-radius: 0;
  }

  .StockPreimpresos_tableTitle__KX3Kf {
    color: black !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/StockPreimpresos/StockPreimpresos.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+CAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,8CAAsB;EACtB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mDAA2B;AAC7B;;AAEA;EACE,sDAA8B;AAChC;;AAEA;EACE,sDAA8B;AAChC;AACA;EACE,sDAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 50px;\n  height: 600px;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: toleft 0.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableTitle {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filters .item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 30px;\n  margin-right: 10px;\n}\n\n.container .filters h4 {\n  font-size: 1.3rem;\n  font-weight: 300;\n  margin-top: 0;\n  animation: toleft 0.5s both;\n}\n\n.container .filters .loaderGames {\n  animation: init 0.5s 0.2s both;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n\n.container .options {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .options p {\n  margin: 0 0 0 10px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media print {\n  @page {\n    size: landscape;\n    margin: 50px 0 50px;\n    quotes: none;\n    visibility: visible;\n  }\n\n  .container .header {\n    display: none !important;\n  }\n\n  .container .filters {\n    display: none !important;\n  }\n\n  .container .data {\n    min-width: 99%;\n  }\n\n  .container .data .tableContainer {\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .tableTitle {\n    color: black !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StockPreimpresos_container__WVcVy`,
	"header": `StockPreimpresos_header__e9bbN`,
	"titleContainer": `StockPreimpresos_titleContainer__gMD8a`,
	"toright": `StockPreimpresos_toright__tussI`,
	"loader": `StockPreimpresos_loader__MdmxO`,
	"data": `StockPreimpresos_data__kz5bp`,
	"tableContainer": `StockPreimpresos_tableContainer__jnJ--`,
	"toleft": `StockPreimpresos_toleft__WPxJZ`,
	"tableTitle": `StockPreimpresos_tableTitle__KX3Kf`,
	"filters": `StockPreimpresos_filters__pynhf`,
	"item": `StockPreimpresos_item__E9H9z`,
	"loaderGames": `StockPreimpresos_loaderGames__Hzcli`,
	"init": `StockPreimpresos_init__jlo0A`,
	"init1": `StockPreimpresos_init1__q6Rpj`,
	"init2": `StockPreimpresos_init2__lBHRC`,
	"options": `StockPreimpresos_options__8PoS3`
};
export default ___CSS_LOADER_EXPORT___;
